"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPVSchema = void 0;
const zod_1 = require("zod");
exports.SPVSchema = zod_1.z.object({
    address: zod_1.z.object({
        street: zod_1.z.string(),
        postCode: zod_1.z.string(),
        city: zod_1.z.string(),
        countryCode: zod_1.z.string(),
    }),
    id: zod_1.z.string(),
    partnerId: zod_1.z.string(),
    owner: zod_1.z.string(),
    email: zod_1.z.string(),
    taxNumber: zod_1.z.string(),
    companyPurpose: zod_1.z.string(),
    companyName: zod_1.z.string(),
    taxOffice: zod_1.z.string(),
    dseDocumentSrc: zod_1.z.string(),
});
//# sourceMappingURL=SPVSchema.js.map